import { S3_DIRECTORY_NAMES } from '@/constants/accessor/s3/directoryName'
import { INSPECTION_CARD_TYPE } from '@/constants/ui/inspection/common/inspectionCardType'
import {
  surroundingOptions,
  differentialSettlementOptions,
  basicsOptions,
  firstFloorSlopeOptions,
  wallOptions,
  corrosionOrTermiteOptions,
  settlementSlopeOptions,
  slopeOptions,
  bucklingOptions,
  braceOptions,
  pillarBeamJointOptions,
  pillarBaseOptions,
  corrosionOptions,
  partsDamageGte3Options,
  groundDestructionSettlementOptions,
  pillarDamage5Options,
  pillarDamage4Options,
  settlementSlopeSteelOptions
} from '@/constants/ui/inspection/step2/step2Card/neighboringSelectOptions'

export const surrounding = {
  title: '隣接建築物・周辺地盤の破壊による危険',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: surroundingOptions,
  key: S3_DIRECTORY_NAMES.SURROUNDING
}

export const differentialSettlement = {
  title: '構造躯体の不同沈下',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: differentialSettlementOptions,
  key: S3_DIRECTORY_NAMES.DIFFERENTIAL_SETTLEMENT
}

export const basics = {
  title: '基礎の被害',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: basicsOptions,
  key: S3_DIRECTORY_NAMES.BASICS
}

export const firstFloorSlope = {
  title: '建築物の1階の傾斜',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: firstFloorSlopeOptions,
  key: S3_DIRECTORY_NAMES.FIRST_FLOOR_SLOPE
}

export const wall = {
  title: '壁の被害',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: wallOptions,
  key: S3_DIRECTORY_NAMES.WALL
}

export const corrosionOrTermite = {
  title: '腐食・蟻害の有無',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: corrosionOrTermiteOptions,
  key: S3_DIRECTORY_NAMES.CORROSION_OR_TERMITE
}

export const settlementSlopeSteel = {
  title: '不同沈下による建築物全体の傾斜',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: settlementSlopeSteelOptions,
  key: S3_DIRECTORY_NAMES.SETTLEMENT_SLOPE_STEEL
}

export const slope = {
  title: '建築物全体又は一部の傾斜',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: slopeOptions,
  key: S3_DIRECTORY_NAMES.SLOPE
}

// titleは先頭に項番がつく前提で定義しています。
//  →front-end/src/constants/ui/inspection/step2/step2Card/getNeighboringCardNumbers.ts: mostDamagedFloor
// inputSelectOption,keyは実装上必要なため定義していますが、当項目はセレクトボックス・画像選択がないため本来は不要
export const mostDamagedFloor = {
  title: 'の調査階(被害最大の階)',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: null,
  key: 'mostDamagedFloor'
}

export const buckling = {
  title: '部材の座屈の有無',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: bucklingOptions,
  key: S3_DIRECTORY_NAMES.BUCKLING
}

export const brace = {
  title: '筋違の破断率',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: braceOptions,
  key: S3_DIRECTORY_NAMES.BRACE
}

export const pillarBeamJoint = {
  title: '柱梁の接合部及び継手の破壊',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: pillarBeamJointOptions,
  key: S3_DIRECTORY_NAMES.PILLAR_BEAM_JOINT
}

export const pillarBase = {
  title: '柱脚の破損',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: pillarBaseOptions,
  key: S3_DIRECTORY_NAMES.PILLAR_BASE
}

export const corrosion = {
  title: '腐食の有無',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: corrosionOptions,
  key: S3_DIRECTORY_NAMES.CORROSION
}

export const settlementSlope = {
  title: '不同沈下による建築物全体の傾斜',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: settlementSlopeOptions,
  key: S3_DIRECTORY_NAMES.SETTLEMENT_SLOPE
}

export const partsDamageGte3 = {
  title: '損傷度Ⅲ以上の損傷部材の有無',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: partsDamageGte3Options,
  key: S3_DIRECTORY_NAMES.PARTS_DAMAGE_GTE_3
}

export const groundDestructionSettlement = {
  title: '地盤破壊による建築物全体の沈下',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: groundDestructionSettlementOptions,
  key: S3_DIRECTORY_NAMES.GROUND_DESTRUCTION_SETTLEMENT
}

export const pillarDamage5 = {
  title: '損傷度Ⅴの柱本数/調査柱本数',
  pattern: INSPECTION_CARD_TYPE.TYPE_B,
  inputSelectOption: pillarDamage5Options,
  key: S3_DIRECTORY_NAMES.PILLAR_DAMAGE_5
}

export const pillarDamage4 = {
  title: '損傷度Ⅳの柱本数/調査柱本数',
  pattern: INSPECTION_CARD_TYPE.TYPE_B,
  inputSelectOption: pillarDamage4Options,
  key: S3_DIRECTORY_NAMES.PILLAR_DAMAGE_4
}
